'use client';

import Layout from '@/components/layout/LayoutWrapper';
import Loader from '@/components/Loader';
import SubscribeContextProvider from '@/components/subscribe/SubscribeContextProvider';
import SubscribeScreens from '@/components/subscribe/SubscribeScreens';
import useB2BRedirect from '@/hooks/utils/useB2BRedirect';

const SubscribeClient = () => {
	const isRedirecting = useB2BRedirect();

	if (isRedirecting) {
		return (
			<div style={{ marginTop: '2rem' }}>
				<Loader color="gray7" />
			</div>
		);
	}

	return (
		<Layout pageName="subscribe" shouldLogViewEvent={false}>
			<SubscribeContextProvider>
				<SubscribeScreens />
			</SubscribeContextProvider>
		</Layout>
	);
};

export default SubscribeClient;
